import * as React from 'react';

import type { IconProps } from './types';

export const Tag = React.forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg width="24" height="24" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" {...props} ref={forwardedRef}>
    <path
      d="M946.224 329.32 695.04 78.136A263.375 263.375 0 0 0 495.427 1.062L218.183 14.37C107.285 19.36 19.122 107.524 13.576 217.867L.268 495.113c-3.327 74.301 24.397 146.939 77.075 199.616l251.184 251.184c49.683 49.538 116.98 77.351 187.14 77.351s137.457-27.814 187.142-77.351l243.415-243.424a262.52 262.52 0 0 0 57.548-85.511c13.349-32.026 20.228-66.376 20.228-101.071s-6.879-69.047-20.228-101.073a262.564 262.564 0 0 0-57.548-85.514zM373.439 533.372c-20.979-.008-41.75-4.147-61.129-12.181s-36.986-19.808-51.814-34.647a159.751 159.751 0 0 1 113.055-272.669 159.75 159.75 0 0 1 159.693 159.804A159.752 159.752 0 0 1 373.44 533.372z"
      fill={color}
    />
  </svg>
));

export default Tag;
